/**
 * Lazy-loads product recommendation markup (same pattern as Dawn).
 */
class ProductRecommendations extends HTMLElement {
  #observer;

  connectedCallback() {
    this.#initialize(this.dataset.productId);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #initialize(productId) {
    if (!productId || !this.dataset.url || !this.dataset.sectionId) return;

    this.#observer?.disconnect();
    this.#observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        this.#load(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.#observer.observe(this);
  }

  #load(productId) {
    const url = `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = doc.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
